import Port1 from "../assets/images/zyena.png";
import Port2 from "../assets/images/minute-master.png";
import Port3 from "../assets/images/relsify.png";
import Port4 from "../assets/images/E-commerce-store-template.png";

export const ProjectData = [
  {
    title: "Zyena",
    image: Port1,
    url: "https://zyena.vercel.app/",
    animationDelay: "w-1",
    tools: "MERN Stack, Tailwindcss, MUI Library",
    id: 1,
  },
  {
    title: "Minute Master",
    image: Port2,
    url: "https://minute-master.com/",
    animationDelay: "w-2",
    tools: "NextJS, Typescript, GrapgQl, TailwindCss",
    id: 2,
  },
  {
    title: "Relsify",
    image: Port3,
    url: "https://www.relsify.com",
    animationDelay: "w-2",
    tools: "REACT, Typescript",
    id: 3,
  },
  {
    title: "E-Commerce store Template",
    image: Port4,
    url: "https://e-commerce-template-shop-it.onrender.com",
    animationDelay: "w-4",
    tools: "MERN Stack, Tailwindcss, MUI Library",
    id: 4,
  },

];
